<template>
  <v-card>
    <v-card-title
      class="d-flex justify-space-between align-center px-6 px-lg-10 py-6"
    >
      <h2 class="ma-0 text-bold font-28 primary--text">{{ title }}</h2>
      <v-btn icon class="btn-close" aria-label="Close" @click="cancel">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text
      :style="`height: ${pslScrollHeight}`"
      class="pl-6 pl-lg-10 pr-1 pr-lg-5 py-6"
    >
      <img
        class="main-img"
        src="@/assets/images/Dialog/EligibilityNotMet/dog_boxer.png"
        alt="dog-look-sad"
      />
      <h2 class="dialog-title text-bold text-center font-28 primary--text">
        Sorry!
      </h2>
      <p class="font-20 primary--text text-center mx-10 mb-0">
        {{
          this.isSelfserve
            ? ELIGIBILITY_NOT_MET_CONTACT_D2C
            : ELIGIBILITY_NOT_MET_UNFORTUNATELY_CURRENT
        }}
      </p>
      <div v-if="this.isSelfserve" class="wrap-contact-infor">
        <p
          class="text-center font-40 primary--text mb-7 font-weight-bold contact-phone-number"
        >
          {{ contactInfo?.PhoneNumber | VMask(PHONE_NUMBER_VMASK) }}
        </p>
        <div class="text-center">
          <p class="font-24 primary--text mb-4 font-weight-bold">
            Opening Hours
          </p>
          <div
            v-for="(itemTime, index) in contactInfo?.BusinessTimes"
            :key="index"
            class="opening-hours"
          >
            <p class="mb-0 font-20 primary--text">
              {{ itemTime?.Description }}:
              {{ itemTime?.OpenTime | timeFormat12h }} -
              {{ itemTime?.CloseTime | timeFormat12h }}
            </p>
          </div>
        </div>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="px-6 px-lg-10 py-6">
      <div class="d-flex flex-column justify-center align-center flex-grow-1">
        <BaseButton
          :text="confirmText"
          rounded
          depressed
          height="60"
          class="font-weight-bold font-20 mb-4"
          :color="'psorange'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '420' : '100%'"
          @click="confirmEligibilityNotMet"
        >
        </BaseButton>

        <a
          href="#"
          @click.prevent="handleBack"
          class="font-18 text-decoration-underline"
          >Go back</a
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import {
  ELIGIBILITY_NOT_MET_UNFORTUNATELY_CURRENT,
  ELIGIBILITY_NOT_MET_CONTACT_D2C,
} from "@/constants/message.constants";
import { PHONE_NUMBER_VMASK } from "@/constants/common.constants";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";

export default {
  name: "EligibilityNotMet",
  components: {
    BaseButton,
  },
  props: {
    cancel: {
      type: Function,
      required: true,
    },
    dialogRef: {
      type: Object,
      required: true,
    },
    dialogNotMet: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isShow: {
      type: Boolean,
      required: false,
    },
    emitEventToParent: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSaveAndExit: {
      type: Boolean,
      required: false,
      default: true,
    },
    confirmText: {
      type: String,
      required: false,
      default: "SAVE & EXIT",
    },
    isSelfserve: {
      type: Boolean,
      required: false,
      default: false,
    },
    pslScrollHeight: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      ELIGIBILITY_NOT_MET_UNFORTUNATELY_CURRENT,
      ELIGIBILITY_NOT_MET_CONTACT_D2C,
      PHONE_NUMBER_VMASK,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["contactInfo"]),
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["handleSaveAndExit"]),
    handleBack() {
      this.dialogNotMet.cancel();
      this.dialogRef.open("Eligibility check");
    },
    returnToHomePage() {
      this.dialogNotMet.cancel();
    },
    confirmEligibilityNotMet() {
      if (this.emitEventToParent) {
        this.dialogNotMet.cancel();
        this.$emit("confirmEligibilityNotMet");
        return;
      }
      if (this.isSaveAndExit) {
        this.handleSaveAndExit();
      } else {
        this.returnToHomePage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-card__title) {
  h2 {
    max-width: 80%;
    word-break: break-word;
  }
}

:deep(.v-card__text) {
  img {
    display: block;
    width: 100%;
    max-width: 338px;
    margin: 0px auto 24px;
  }
  .contact-phone-number {
    color: $gray-dark-2;
    font-size: 40px;
  }
  .opening-hours {
    line-height: normal;
  }

  .dialog-title {
    margin-bottom: 23px;
  }

  .wrap-contact-infor {
    margin-top: 28px;
  }
}
</style>
